import { createApp, markRaw } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import { FreeMode, Navigation, Thumbs } from "swiper"

// Estilos
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/navigation"
import "swiper/css/thumbs"

const app = createApp({
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            // markRaw: instância do Swiper dentro do reactive vira Proxy e o módulo
            // Thumbs perde a referência — clicar na miniatura não trocava o slide.
            thumbsSwiper: null,
            mainSwiper: null,
            Thumbs,
            Navigation,
            FreeMode,
        }
    },
    methods: {
        setThumbs(swiper) {
            this.thumbsSwiper = markRaw(swiper)
        },
        setMain(swiper) {
            this.mainSwiper = markRaw(swiper)
        },
        // Fallback explícito ao módulo Thumbs: a miniatura clicada vira o slide principal.
        irPara(i) {
            if (this.mainSwiper) this.mainSwiper.slideTo(i)
        },
    },
})

app.mount("#offer-container")
